import { withChartLayout } from 'components/common';
import MedicalHistory from 'components/features/chart/provider-chart/history-physical/medical-history/MedicalHistory';

const MedicalHistoryPage = withChartLayout('Medical History')(MedicalHistory);
export default MedicalHistoryPage;
